import { render, staticRenderFns } from "./brandInfo.vue?vue&type=template&id=fecc9aa4"
import script from "./brandInfo.vue?vue&type=script&lang=js"
export * from "./brandInfo.vue?vue&type=script&lang=js"
import style0 from "./brandInfo.vue?vue&type=style&index=0&id=fecc9aa4&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fecc9aa4')) {
      api.createRecord('fecc9aa4', component.options)
    } else {
      api.reload('fecc9aa4', component.options)
    }
    module.hot.accept("./brandInfo.vue?vue&type=template&id=fecc9aa4", function () {
      api.rerender('fecc9aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/brandInfo.vue"
export default component.exports